import React from "react";

interface HtmlContentProps {
    html: string;
    className: string,
}

const HtmlContent: React.FC<HtmlContentProps> = ({html, className}) => {
    return (
        <div dangerouslySetInnerHTML={{__html: html}} className={className}/>
    );
};

export default HtmlContent;